export class Engagement {
  static readonly type = '[EngagementData] Engagement';
}

export class UpdateEngagementData {
  static readonly type = '[EngagementData] Update';
  constructor(public payload: any) {}
}
